module.exports = __webpack_public_path__ + "assets/images/USD2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD2.png
// module id = 1454
// module chunks = 1